import { InternalCompilerError } from './../../InternalCompilerError';
import { ReturnBlock } from "../ReturnBlock";
import { ANDBlock } from "../returnBlocks/boolean/operators/ANDBlock";
import { VoidBlock } from "../VoidBlock";

export class WHILEBlock extends VoidBlock {
    conditions;
    blocks;
    len: number;

    /**
     * Constructor
     * @param conditions the number of iterations (boolean)
     * @param blocks array of void blocks to execute while condition is true
     */
    constructor(id: string, conditions: ReturnBlock[], blocks: VoidBlock[]) {
        super(id)
        this.conditions = conditions;
        this.blocks = blocks;

        this.len = 0;
        for (let b of blocks) {
            this.len += b.getLength();
        }
    }


    /**
     * If the condition evaluates to true, all blocks are ran. The cycle is repeated untill condition evaluates to false.
     * @param varEnv the variable envornment
     */
    *evalBlock(varEnv: Map<string, any>) {
        while (true) {
            let andBlock: ANDBlock = new ANDBlock(this.id, this.conditions);
            let cond = andBlock.evalBlock(varEnv);

            if (!cond) return;

            for (let block of this.blocks) {
                if (!(block instanceof VoidBlock)) throw new InternalCompilerError('Loop body must be void');

                let gen = block.evalBlock(varEnv);

                let status;
                do {
                    status = gen.next();
                    yield;
                } while (!status.done)

            }
        }
    }

    /**
     * Returns the minimum number of steps required to complete a single iteration of the loop.
     */
    getLength() {
        return this.len;
    }
}
